import config from "../../assets/js/conf/config";
import request from "../../assets/js/utils/request";
/**
 * 我的钱包
 */
export function moneyData(data){//获取钱包金额信息
	return request.post(config.baseApi+"/supplier/suppliermoneyinfo",data)
}
export function tixianInfo(data){//获取提现信息
	return request.post(config.baseApi+"/supplier/suppliertixianinfo",data)
}
export function tixianData(data){//发起提现
	return request.post(config.baseApi+"/supplier/suppliertixian",data)
}
export function walletData(data){//钱包记录流水
	return request.post(config.baseApi+"/supplier/supplierjineflow",data)
}
export function paymentCode(data){//获取支付二维码
	return request.post(config.baseApi+"/supplier/paymentcode",data)
}
export function mywalletCheckPayState(data){
	return request.get(config.baseApi+"/supplier/Mywallet/checkPayState",data)
}
/**
 * 个人设置
 */
export function setAvatar(data){//更换头像
	return request.post(config.baseApi+"/supplier/supplierediticon",data)
}
export function changePhone(data){//换绑手机
	return request.post(config.baseApi+"/supplier/suppliereditmobile",data)
}
export function changePwd(data){//更改密码
	return request.post(config.baseApi+"/supplier/suppliereditpassword",data)
}
export function changeRemind(data){//接收公众号提醒
	return request.post(config.baseApi+"/supplier/suppliersetwxremind",data)
}
export function zfbList(data){//获取支付宝列表
	return request.post(config.baseApi+"/supplier/supplierzfbinfo",data)
}
export function zfbAdd(data){//新增支付宝账户
	return request.post(config.baseApi+"/supplier/supplierzfbadd",data)
}
export function zfbDelete(data){//删除支付宝账户
	return request.post(config.baseApi+"/supplier/supplierzfbdel",data)
}
export function zfbEdit(data){//编辑支付宝账户
	return request.post(config.baseApi+"/supplier/supplierzfbedit",data)
}
export function zfbSet(data){//选择默认支付宝账户
	return request.post(config.baseApi+"/supplier/supplierzfbset",data)
}
export function usableBank(data){//获取可选银行列表
	return request.post(config.baseApi+"/supplier/supplierbanklist",data)
}
export function bankList(data){//获取银行卡列表
	return request.post(config.baseApi+"/supplier/supplieryhkinfo",data)
}
export function bankAdd(data){//新增银行卡账户
	return request.post(config.baseApi+"/supplier/supplieryhkadd",data)
}
export function bankDelete(data){//删除银行卡账户
	return request.post(config.baseApi+"/supplier/supplieryhkdel",data)
}
export function bankEdit(data){//编辑银行卡账户
	return request.post(config.baseApi+"/supplier/supplieryhkedit",data)
}
export function bankSet(data){//选择默认银行卡账户
	return request.post(config.baseApi+"/supplier/supplieryhkset",data)
}
export function changeSupplierDrawingBill(data){//更改寄件快递费
	return request.post(config.baseApi+"/supplier/suppliereditdrawingbill",data)
}

//商品相关
export function productTaskList(data){//复制任务列表
	return request.get(config.baseApi+"/supplier/SupplierProductTask/list",data)
}
export function productTaskAdd(data){//一键复制
	return request.post(config.baseApi+"/supplier/SupplierProductTask/add",data)
}
export function productTaskDel(data){//删除任务
	return request.post(config.baseApi+"/supplier/SupplierProductTask/del",data)
}
export function productQueueList(data){//复制任务明细列表
	return request.get(config.baseApi+"/supplier/SupplierProductQueue/list",data)
}
export function productList(data){//商品列表
	return request.get(config.baseApi+"/supplier/SupplierProduct/list",data)
}
export function puhuoErrorCollectList(data){//铺货失败列表
	return request.post(config.baseApi+"/supplier/SupplierProduct/puhuo_error_collect_list",data)
}
export function deletePhError(data){//铺货失败列表
	return request.post(config.baseApi+"/supplier/SupplierProduct/delete_ph_error",data)
}
export function productDel(data){//删除商品
	return request.post(config.baseApi+"/supplier/SupplierProduct/del",data)
}
export function productBatOnSale(data){//商品批量上架
	return request.post(config.baseApi+"/supplier/SupplierProduct/bat_on_sale",data)
}
export function productBatOffSale(data){//商品批量下架
	return request.post(config.baseApi+"/supplier/SupplierProduct/bat_off_sale",data)
}
export function productFilterData(data){//商品搜索数据
	return request.get(config.baseApi+"/supplier/SupplierProduct/filter_data",data)
}
export function productLeafCateList(data){//异步获取下级分类列表
	return request.get(config.baseApi+"/supplier/SupplierProduct/leaf_cate_list",data)
}
export function batProductEditPrice(data){//商品批量改价
	return request.post(config.baseApi+"/supplier/SupplierProduct/bat_edit_price",data)
}
export function productEditInfo(data){//商品修改信息
	return request.post(config.baseApi+"/supplier/SupplierProduct/edit_info",data)
}
export function supplierAddress(data){//地址管理
	return request.get(config.baseApi+"/supplier/SupplierAddress/index",data)
}
export function supplierAddressEdit(data){//地址管理-编辑
	return request.post(config.baseApi+"/supplier/SupplierAddress/edit",data)
}
export function supplierRegionList(data){//获取下级地区
	return request.post(config.baseApi+"/supplier/SupplierAddress/region_list",data)
}
export function supplierShopList(data){//获取抖店列表
	return request.get(config.baseApi+"/supplier/SupplierProduct/dd_shop_list",data)
}
export function syncProduct(data){//同步抖店商品
	return request.post(config.baseApi+"/supplier/SupplierProduct/sync_dd_product",data)
}


// 订单管理
export function supplierOrderList(data){//订单列表
	return request.get(config.baseApi+"/supplier/SupplierOrder/list",data)
}
export function supplierOrderAddressInfo(data){//查看收货人信息
	return request.get(config.baseApi+"/supplier/SupplierOrder/addressInfo",data)
}
export function supplierOrderFilterData(data){//获取订单筛选数据
	return request.get(config.baseApi+"/supplier/SupplierOrder/filterData",data)
}
export function supplierOrderDetail(data){//订单详情
	return request.get(config.baseApi+"/supplier/SupplierOrder/detail",data)
}
export function supplierOrderDeliver(data){//订单发货
	return request.post(config.baseApi+"/supplier/SupplierOrder/deliver",data)
}
export function supplierOrderDeliverInfo(data){//订单发货信息
	return request.get(config.baseApi+"/supplier/SupplierOrder/deliverInfo",data)
}
export function supplierGetOperateInfo(data){//售后操作数据
	return request.get(config.baseApi+"/supplier/SupplierOrder/getOperateInfo",data)
}
export function supplierOpAfterSale(data){//售后操作执行
	return request.post(config.baseApi+"/supplier/SupplierOrder/opAfterSale",data)
}
export function supplierAuditRefund(data){//已发货仅退款审核（抖店自动同意退款的情况）
	return request.post(config.baseApi+"/supplier/SupplierOrder/auditRefund",data)
}
export function supplierKdnLcb(data){//已绑定合作网点列表
	return request.get(config.baseApi+"/supplier/SupplierKdnLcb/index",data)
}
export function unboundLogisticsCompany(data){//供应商未绑定网点账号的物流公司列表
	return request.get(config.baseApi+"/supplier/SupplierKdnLcb/unboundLogisticsCompany",data)
}
export function subBindLogisticsCompany(data){//添加绑定网点账号的物流公司
	return request.post(config.baseApi+"/supplier/SupplierKdnLcb/subBindLogisticsCompany",data)
}
export function delBindLogisticsCompany(data){//删除绑定网点账号的物流公司
	return request.post(config.baseApi+"/supplier/SupplierKdnLcb/del",data)
}
export function boundLogisticsCompany(data){//获取已绑定合作网点的物流公司
	return request.get(config.baseApi+"/supplier/SupplierKdnLcb/boundLogisticsCompany",data)
}
export function editFreightPrice(data){//更新供应商统一运费
	return request.post(config.baseApi+"/supplier/SupplierKdnLcb/editFreightPrice",data)
}
export function setDefaultNetsite(data){//设置供应商默认快递网点
	return request.post(config.baseApi+"/supplier/SupplierKdnLcb/setDefaultNetsite",data)
}
export function createPrintOrder(data){//提交生成电子面单
	return request.post(config.baseApi+"/supplier/SupplierOrder/createPrintOrder",data)
}
export function orderPrintInfo(data){//获取单个电子面单信息
	return request.get(config.baseApi+"/supplier/SupplierOrder/orderPrintInfo",data)
}
export function batDeliverOrderData(data){//获取打单发货的待发货信息
	return request.get(config.baseApi+"/supplier/SupplierOrder/batDeliverOrderData",data)
}
export function supplierOrderTrackDetail(data){//获取物流轨迹
	return request.get(config.baseApi+"/supplier/SupplierOrder/trackDetail",data)
}

export function supplierNetsite(data){//获取已绑定快递网点
	return request.get(config.baseApi+"/supplier/SupplierNetsite/index",data)
}
export function supplierCancelBill(data){//取消电子面单(抖店)
	return request.post(config.baseApi+"/supplier/SupplierOrder/cancelBill",data)
}

export function supplierMakeOrderBills(data){//生成进货单据信息
	return request.post(config.baseApi+"/supplier/SupplierOrder/makeOrderBills",data)
}
export function orderBills(data){//分页获取进货单打印
	return request.get(config.baseApi+"/supplier/SupplierOrder/getOrderBills",data)
}
export function makeOrderProductTags(data){//生成订单商品标签记录
	return request.get(config.baseApi+"/supplier/SupplierOrder/makeOrderProductTags",data)
}
export function orderTags(data){//分页获取订单商品标签打印
	return request.get(config.baseApi+"/supplier/SupplierOrder/orderTags",data)
}
export function editOrderProductRemark(data){//订单商品表备注
	return request.post(config.baseApi+"/supplier/SupplierOrder/editOrderProductRemark",data)
}
export function orderProductOutOfStock(data){//订单商品缺货
	return request.post(config.baseApi+"/supplier/SupplierOrder/orderProductOutOfStock",data)
}

/**
 * 自动打单发货
 */
export function orderAutoPrintDelivery(data){//自动打单发货
	return request.post(config.baseApi+"/supplier/AutoPrintDelivery/index",data)
}
export function orderCancelBill(data){//取消电子面单(抖店)
	return request.post(config.baseApi+"/supplier/AutoPrintDelivery/cancelBill",data)
}
export function supplierPrintInfo(data){//获取订单打印信息
	return request.get(config.baseApi+"/supplier/AutoPrintDelivery/getPrintInfo",data)
}

/**
 * 推广中心
 */
export function extendUrl(data){//获取推广中心链接
	return request.post(config.baseApi+"/supplier/suppliertgurl",data)
}
export function extendList(data){//获取推广中心合作列表
	return request.post(config.baseApi+"/supplier/suppliertglist",data)
}
/**
 * 岗位管理，员工管理，重置密码
 */
export function supplierRoleIndex(data){//岗位管理列表
	return request.post(config.baseApi+"/supplier/System.Supplierrole/index",data)
}
export function supplierRoleMenus(data){//权限系统获取菜单
	return request.post(config.baseApi+"/supplier/System.Supplierrole/getRoleMenus",data)
}
export function supplierRoleAdd(data){//添加岗位
	return request.post(config.baseApi+"/supplier/System.Supplierrole/add",data)
}
export function supplierRoleUpdate(data){//更新岗位设置
	return request.post(config.baseApi+"/supplier/System.Supplierrole/update",data)
}
export function supplierRoleDel(data){//删除岗位
	return request.post(config.baseApi+"/supplier/System.Supplierrole/delete",data)
}
export function supplierRoleInfo(data){//岗位信息
	return request.post(config.baseApi+"/supplier/System.Supplierrole/getUpdateInfo",data)
}
export function supplierRoleExt(data){//岗位禁用状态
	return request.post(config.baseApi+"/supplier/System.Supplierrole/updateExt",data)
}
export function agentuserIndex(data){//员工列表
	return request.post(config.baseApi+"/supplier/System.Agentuser/index",data)
}
export function agentuserFieldList(data){//获取岗位信息
	return request.post(config.baseApi+"/supplier/System.Agentuser/getFieldList",data)
}
export function agentuserAdd(data){//添加员工
	return request.post(config.baseApi+"/supplier/System.Agentuser/add",data)
}
export function agentuserDel(data){//删除员工
	return request.post(config.baseApi+"/supplier/System.Agentuser/delete",data)
}
export function agentuserInfo(data){//查询员工修改信息
	return request.post(config.baseApi+"/supplier/System.Agentuser/getUpdateInfo",data)
}
export function agentuserUpdate(data){//更新员工
	return request.post(config.baseApi+"/supplier/System.Agentuser/update",data)
}
export function agentuserResetPwd(data){//重置密码
	return request.post(config.baseApi+"/supplier/System.Agentuser/resetPwd",data)
}
export function agentuserExt(data){//修改员工显示状态
	return request.post(config.baseApi+"/supplier/System.Agentuser/updateExt",data)
}

export function shelvesList(data){//货架列表
	return request.get(config.baseApi+"/supplier/ProductShelves/index",data)
}
export function shelvesAdd(data){//添加货架
	return request.post(config.baseApi+"/supplier/ProductShelves/add",data)
}
export function shelvesInfo(data){//货架信息
	return request.post(config.baseApi+"/supplier/ProductShelves/info",data)
}
export function shelvesUpdate(data){//更新货架
	return request.post(config.baseApi+"/supplier/ProductShelves/update",data)
}
export function shelvesDel(data){//删除货架
	return request.post(config.baseApi+"/supplier/ProductShelves/delete",data)
}

export function allocationList(data){//货位列表
	return request.get(config.baseApi+"/supplier/ProductAllocation/index",data)
}
export function allocationAdd(data){//添加货位
	return request.post(config.baseApi+"/supplier/ProductAllocation/add",data)
}
export function allocationDel(data){//删除货位
	return request.post(config.baseApi+"/supplier/ProductAllocation/delete",data)
}

export function stallsList(data){//档口列表
	return request.get(config.baseApi+"/supplier/ProductStalls/index",data)
}
export function stallsAdd(data){//添加档口
	return request.post(config.baseApi+"/supplier/ProductStalls/add",data)
}
export function stallsInfo(data){//档口信息
	return request.post(config.baseApi+"/supplier/ProductStalls/info",data)
}
export function stallsUpdate(data){//更新档口
	return request.post(config.baseApi+"/supplier/ProductStalls/update",data)
}
export function stallsDel(data){//删除档口
	return request.post(config.baseApi+"/supplier/ProductStalls/delete",data)
}
export function allStallsList(data){//全部档口
	return request.get(config.baseApi+"/supplier/SupplierProduct/stalls_list",data)
}

/**
 * 我的抖店
 */
export function ddShopList(data){//获取我的抖店列表
	return request.get(config.baseApi+"/supplier/DdShop/list",data)
}
export function ddShopDel(data){//删除抖店
	return request.post(config.baseApi+"/supplier/DdShop/del",data)
}
export function ddSetDefaultShareBill(data){//删除抖店
	return request.post(config.baseApi+"/supplier/DdShop/ddSetDefaultShareBill",data)
}
export function ddShopNetSiteList(data){//获取快递网点
	return request.get(config.baseApi+"/supplier/DdShop/shopNetSiteList",data)
}

export function getFreightTemplateRegionList(data){
	return request.get(config.baseApi+"/supplier/FreightTemplate/regionList", data)
}
export function getFreightTemplateList(data){
	return request.get(config.baseApi+"/supplier/FreightTemplate/index",data)
}
export function addFreightTemplate(data){
	return request.post(config.baseApi+"/supplier/FreightTemplate/add",data)
}
export function updateFreightTemplate(data){
	return request.post(config.baseApi+"/supplier/FreightTemplate/update",data)
}
export function deleteFreightTemplate(data){
	return request.post(config.baseApi+"/supplier/FreightTemplate/delete",data)
}
export function productInviteCode(data){
	return request.get(config.baseApi+"/supplier/User/productInviteCode",data)
}
export function updateProductInviteCode(data){
	return request.post(config.baseApi+"/supplier/User/updateProductInviteCode",data)
}